import React from "react";
import { Avatar, Info, List, Row } from "./styles";

/**
 * items: Array<{
 *   id: string,
 *   name: string,
 *   subtitle?: string,
 *   avatarUrl?: string,   // if present, avatar is rendered
 *   badge?: ReactNode,    // right-side slot
 * }>
 */
const PersonList = ({ items }) => (
  <List>
    {items.map((item) => (
      <Row key={item.id}>
        {item.avatarUrl !== undefined && <Avatar src={item.avatarUrl} />}
        <Info>
          <span className="name">{item.name}</span>
          {item.subtitle && <span className="subtitle">{item.subtitle}</span>}
        </Info>
        {item.badge && <div>{item.badge}</div>}
      </Row>
    ))}
  </List>
);

export default PersonList;
